export default __webpack_public_path__ + "static/media/close-cross.4fe51c5b.svg";